import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useArpMedia } from '../../../__legacy__/queries/arpMedia'
import { useUser } from '../../../__legacy__/queries/users'
import { detailPagePath } from '../../arp-media-utils'
import { profilePath } from '../../profile'
import { Notification } from '../primatives'
import { ArpUsedNotificationType } from '../types'
import { notificationTimeAgo } from '../utils'

interface Props {
  notification: ArpUsedNotificationType
}

export const ActivityUsedNotification: FC<Props> = ({ notification }) => {
  const parentArpQuery = useArpMedia({ id: notification.data.arpId })
  const usedByQuery = useUser({ walletAddressOrId: notification.data.triggeredByWalletAddress })
  const usedWithQuery = useArpMedia({ id: notification.data.triggeredByArpId })

  if (usedByQuery.isLoading || usedWithQuery.isLoading || parentArpQuery.isLoading) {
    return null
  }

  return (
    <Notification.Root>
      <Notification.Avatar src={usedByQuery.data.profilePicture?.url} />
      <Notification.Title>
        {`Featured by`}
        <Link to={profilePath(usedByQuery.data)}>
          <Notification.Link css={{ marginLeft: '4px' }}>
            {usedByQuery.data.displayName}
          </Notification.Link>
        </Link>
        {`in`}
        <Link to={detailPagePath(usedWithQuery.data)}>
          <Notification.Link css={{ marginLeft: '4px' }}>
            {usedWithQuery.data.metadata.title}
          </Notification.Link>
        </Link>
      </Notification.Title>
      <Notification.Stats>{notificationTimeAgo(usedWithQuery.data.createdAt)}</Notification.Stats>
    </Notification.Root>
  )
}
